import React, { useEffect, useState } from 'react';
import { useAddAdacEntitlement } from '@/apiHooks/entitlements.hook';
import { useGetHasEntitlement } from '@/customHooks/useGetHasEntitlement.hook';
import { EntitlementType } from '@/@types/entitlement';

import { AdminPage } from './AdminPage';
import { resetBenefitsViewedStatus } from '../../../api/benefits/benefits';
import { getLogger } from '../../../utils/logger/logger';
import { getUserInteractions } from '../../../api/userInteractions/userInteractions';

export const AdminPageContainer = () => {
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const { addEntitlement, isAddingEntitlement, addEntitlementFailed } = useAddAdacEntitlement();
  const hasAdacEntitlement = useGetHasEntitlement(EntitlementType.ADAC_WP);

  useEffect(() => {
    (async () => {
      await getUserInteractions();
    })();
  }, []);

  const onResetNavigationDots = async () => {
    setIsRequestInProgress(true);
    try {
      await resetBenefitsViewedStatus();
      setIsRequestInProgress(false);
    } catch (error) {
      getLogger('AdminPageContainer resetBenefitsViewedStatus').error({ error });
      setError(error);
    }
  };

  if (error) throw error;

  return (
    <AdminPage
      isRequestInProgress={isRequestInProgress || isAddingEntitlement}
      onResetNavigationDots={onResetNavigationDots}
      onAddAdacWp={() => addEntitlement()}
      hasAdacEntitlement={hasAdacEntitlement}
      addEntitlementsFailed={addEntitlementFailed}
    />
  );
};
